export const emojiList = [
    // Smileys & Emotion
    { char: '😀', keywords: 'grinning face smile happy', category: 'smileys' },
    { char: '😃', keywords: 'grinning face with big eyes smile happy', category: 'smileys' },
    { char: '😄', keywords: 'grinning face with smiling eyes smile happy', category: 'smileys' },
    { char: '😁', keywords: 'beaming face with smiling eyes smile happy', category: 'smileys' },
    { char: '😆', keywords: 'grinning squinting face smile happy laugh', category: 'smileys' },
    { char: '😅', keywords: 'grinning face with sweat smile hot', category: 'smileys' },
    { char: '🤣', keywords: 'rolling on the floor laughing smile laugh rofl', category: 'smileys' },
    { char: '😂', keywords: 'face with tears of joy smile laugh cry', category: 'smileys' },
    { char: '🙂', keywords: 'slightly smiling face smile', category: 'smileys' },
    { char: '🙃', keywords: 'upside-down face smile silly', category: 'smileys' },
    { char: '😉', keywords: 'winking face smile wink', category: 'smileys' },
    { char: '😊', keywords: 'smiling face with smiling eyes smile happy blush', category: 'smileys' },
    { char: '😇', keywords: 'smiling face with halo angel', category: 'smileys' },
    { char: '🥰', keywords: 'smiling face with hearts love', category: 'smileys' },
    { char: '😍', keywords: 'smiling face with heart-eyes love', category: 'smileys' },
    { char: '🤩', keywords: 'star-struck love eyes', category: 'smileys' },
    { char: '😘', keywords: 'face blowing a kiss love', category: 'smileys' },
    { char: '😗', keywords: 'kissing face love', category: 'smileys' },
    { char: '😚', keywords: 'kissing face with closed eyes love', category: 'smileys' },
    { char: '😙', keywords: 'kissing face with smiling eyes love', category: 'smileys' },
    { char: '😋', keywords: 'face savoring food yum hungry', category: 'smileys' },
    { char: '😛', keywords: 'face with tongue silly', category: 'smileys' },
    { char: '😜', keywords: 'winking face with tongue silly wink', category: 'smileys' },
    { char: '🤪', keywords: 'zany face silly crazy', category: 'smileys' },
    { char: '😝', keywords: 'squinting face with tongue silly', category: 'smileys' },
    { char: '🤑', keywords: 'money-mouth face rich money', category: 'smileys' },
    { char: '🤗', keywords: 'hugging face hug', category: 'smileys' },
    { char: '🤭', keywords: 'face with hand over mouth oops', category: 'smileys' },
    { char: '🤫', keywords: 'shushing face quiet silence', category: 'smileys' },
    { char: '🤔', keywords: 'thinking face think wonder', category: 'smileys' },
    { char: '🤐', keywords: 'zipper-mouth face quiet silence', category: 'smileys' },
    { char: '🤨', keywords: 'face with raised eyebrow skeptical', category: 'smileys' },
    { char: '😐', keywords: 'neutral face meh', category: 'smileys' },
    { char: '😑', keywords: 'expressionless face meh', category: 'smileys' },
    { char: '😶', keywords: 'face without mouth silent', category: 'smileys' },
    { char: '😏', keywords: 'smirking face smirk', category: 'smileys' },
    { char: '😒', keywords: 'unamused face not amused', category: 'smileys' },
    { char: '🙄', keywords: 'face with rolling eyes eye roll', category: 'smileys' },
    { char: '😬', keywords: 'grimacing face grimace', category: 'smileys' },
    { char: '🤥', keywords: 'lying face lie pinocchio', category: 'smileys' },
    { char: '😌', keywords: 'relieved face relief', category: 'smileys' },
    { char: '😔', keywords: 'pensive face sad', category: 'smileys' },
    { char: '😪', keywords: 'sleepy face sleep', category: 'smileys' },
    { char: '🤤', keywords: 'drooling face hungry sleep', category: 'smileys' },
    { char: '😴', keywords: 'sleeping face sleep zzz', category: 'smileys' },
    { char: '😷', keywords: 'face with medical mask sick covid', category: 'smileys' },
    { char: '🤒', keywords: 'face with thermometer sick fever', category: 'smileys' },
    { char: '🤕', keywords: 'face with head-bandage hurt', category: 'smileys' },
    { char: '🤢', keywords: 'nauseated face sick vomit', category: 'smileys' },
    { char: '🤮', keywords: 'face vomiting sick vomit', category: 'smileys' },
    { char: '🤧', keywords: 'sneezing face sick sneeze', category: 'smileys' },
    { char: '🥵', keywords: 'hot face hot heat', category: 'smileys' },
    { char: '🥶', keywords: 'cold face cold freeze', category: 'smileys' },
    { char: '🥴', keywords: 'woozy face drunk sick', category: 'smileys' },
    { char: '😵', keywords: 'dizzy face dizzy', category: 'smileys' },
    { char: '🤯', keywords: 'exploding head mind blown', category: 'smileys' },
    { char: '🤠', keywords: 'cowboy hat face cowboy', category: 'smileys' },
    { char: '🥳', keywords: 'partying face party celebration', category: 'smileys' },
    { char: '😎', keywords: 'smiling face with sunglasses cool', category: 'smileys' },
    { char: '🤓', keywords: 'nerd face nerd smart', category: 'smileys' },
    { char: '🧐', keywords: 'face with monocle smart fancy', category: 'smileys' },
    { char: '😕', keywords: 'confused face confused', category: 'smileys' },
    { char: '😟', keywords: 'worried face worried', category: 'smileys' },
    { char: '🙁', keywords: 'slightly frowning face sad', category: 'smileys' },
    { char: '☹️', keywords: 'frowning face sad', category: 'smileys' },
    { char: '😮', keywords: 'face with open mouth wow', category: 'smileys' },
    { char: '😯', keywords: 'hushed face quiet', category: 'smileys' },
    { char: '😲', keywords: 'astonished face wow', category: 'smileys' },
    { char: '😳', keywords: 'flushed face blush', category: 'smileys' },
    { char: '🥺', keywords: 'pleading face please', category: 'smileys' },
    { char: '😦', keywords: 'frowning face with open mouth sad', category: 'smileys' },
    { char: '😧', keywords: 'anguished face sad', category: 'smileys' },
    { char: '😨', keywords: 'fearful face fear scared', category: 'smileys' },
    { char: '😰', keywords: 'anxious face with sweat scared', category: 'smileys' },
    { char: '😥', keywords: 'sad but relieved face relief', category: 'smileys' },
    { char: '😢', keywords: 'crying face sad cry', category: 'smileys' },
    { char: '😭', keywords: 'loudly crying face sad cry', category: 'smileys' },
    { char: '😱', keywords: 'face screaming in fear scared scream', category: 'smileys' },
    { char: '😖', keywords: 'confounded face sad', category: 'smileys' },
    { char: '😣', keywords: 'persevering face sad', category: 'smileys' },
    { char: '😞', keywords: 'disappointed face sad', category: 'smileys' },
    { char: '😓', keywords: 'downcast face with sweat sad', category: 'smileys' },
    { char: '😩', keywords: 'weary face sad tired', category: 'smileys' },
    { char: '😫', keywords: 'tired face sad tired', category: 'smileys' },
    { char: '😤', keywords: 'face with steam from nose angry', category: 'smileys' },
    { char: '😡', keywords: 'pouting face angry mad', category: 'smileys' },
    { char: '😠', keywords: 'angry face angry mad', category: 'smileys' },
    { char: '🤬', keywords: 'face with symbols on mouth angry swear', category: 'smileys' },
    { char: '😈', keywords: 'smiling face with horns devil evil', category: 'smileys' },
    { char: '👿', keywords: 'angry face with horns devil evil', category: 'smileys' },
    { char: '💀', keywords: 'skull death dead', category: 'smileys' },
    { char: '☠️', keywords: 'skull and crossbones death dead', category: 'smileys' },
    { char: '💩', keywords: 'pile of poo poop', category: 'smileys' },
    { char: '🤡', keywords: 'clown face clown', category: 'smileys' },
    { char: '👹', keywords: 'ogre monster', category: 'smileys' },
    { char: '👺', keywords: 'goblin monster', category: 'smileys' },
    { char: '👻', keywords: 'ghost halloween', category: 'smileys' },
    { char: '👽', keywords: 'alien space', category: 'smileys' },
    { char: '👾', keywords: 'alien monster game', category: 'smileys' },
    { char: '🤖', keywords: 'robot', category: 'smileys' },

    // Nature
    { char: '🐶', keywords: 'dog face pet animal', category: 'nature' },
    { char: '🐱', keywords: 'cat face pet animal', category: 'nature' },
    { char: '🐭', keywords: 'mouse face animal', category: 'nature' },
    { char: '🐹', keywords: 'hamster face pet animal', category: 'nature' },
    { char: '🐰', keywords: 'rabbit face animal bunny', category: 'nature' },
    { char: '🦊', keywords: 'fox face animal', category: 'nature' },
    { char: '🐻', keywords: 'bear face animal', category: 'nature' },
    { char: '🐼', keywords: 'panda face animal', category: 'nature' },
    { char: '🐨', keywords: 'koala animal', category: 'nature' },
    { char: '🐯', keywords: 'tiger face animal', category: 'nature' },
    { char: '🦁', keywords: 'lion face animal', category: 'nature' },
    { char: '🐮', keywords: 'cow face animal', category: 'nature' },
    { char: '🐷', keywords: 'pig face animal', category: 'nature' },
    { char: '🐽', keywords: 'pig nose animal', category: 'nature' },
    { char: '🐸', keywords: 'frog animal', category: 'nature' },
    { char: '🐵', keywords: 'monkey face animal', category: 'nature' },
    { char: '🙈', keywords: 'see-no-evil monkey animal', category: 'nature' },
    { char: '🙉', keywords: 'hear-no-evil monkey animal', category: 'nature' },
    { char: '🙊', keywords: 'speak-no-evil monkey animal', category: 'nature' },
    { char: '🐒', keywords: 'monkey animal', category: 'nature' },
    { char: '🐔', keywords: 'chicken animal', category: 'nature' },
    { char: '🐧', keywords: 'penguin animal', category: 'nature' },
    { char: '🐦', keywords: 'bird animal', category: 'nature' },
    { char: '🐤', keywords: 'baby chick animal', category: 'nature' },
    { char: '🐣', keywords: 'hatching chick animal', category: 'nature' },
    { char: '🐥', keywords: 'front-facing baby chick animal', category: 'nature' },
    { char: '🦆', keywords: 'duck animal', category: 'nature' },
    { char: '🦅', keywords: 'eagle animal', category: 'nature' },
    { char: '🦉', keywords: 'owl animal', category: 'nature' },
    { char: '🦇', keywords: 'bat animal', category: 'nature' },
    { char: '🐺', keywords: 'wolf animal', category: 'nature' },
    { char: '🐗', keywords: 'boar animal', category: 'nature' },
    { char: '🐴', keywords: 'horse face animal', category: 'nature' },
    { char: '🦄', keywords: 'unicorn face animal fantasy', category: 'nature' },
    { char: '🐝', keywords: 'honeybee insect', category: 'nature' },
    { char: '🐛', keywords: 'bug insect', category: 'nature' },
    { char: '🦋', keywords: 'butterfly insect', category: 'nature' },
    { char: '🐌', keywords: 'snail insect', category: 'nature' },
    { char: '🐞', keywords: 'lady beetle insect', category: 'nature' },
    { char: '🐜', keywords: 'ant insect', category: 'nature' },
    { char: '🦟', keywords: 'mosquito insect', category: 'nature' },
    { char: '🦗', keywords: 'cricket insect', category: 'nature' },
    { char: '🕷', keywords: 'spider insect', category: 'nature' },
    { char: '🕸', keywords: 'spider web insect', category: 'nature' },
    { char: '🦂', keywords: 'scorpion insect', category: 'nature' },
    { char: '🐢', keywords: 'turtle animal', category: 'nature' },
    { char: '🐍', keywords: 'snake animal reptile', category: 'nature' },
    { char: '🦎', keywords: 'lizard animal reptile', category: 'nature' },
    { char: '🦖', keywords: 't-rex dinosaur animal', category: 'nature' },
    { char: '🦕', keywords: 'sauropod dinosaur animal', category: 'nature' },
    { char: '🐙', keywords: 'octopus animal ocean', category: 'nature' },
    { char: '🦑', keywords: 'squid animal ocean', category: 'nature' },
    { char: '🦐', keywords: 'shrimp animal ocean', category: 'nature' },
    { char: '🦞', keywords: 'lobster animal ocean', category: 'nature' },
    { char: '🦀', keywords: 'crab animal ocean', category: 'nature' },
    { char: '🐡', keywords: 'blowfish animal ocean', category: 'nature' },
    { char: '🐠', keywords: 'tropical fish animal ocean', category: 'nature' },
    { char: '🐟', keywords: 'fish animal ocean', category: 'nature' },
    { char: '🐬', keywords: 'dolphin animal ocean', category: 'nature' },
    { char: '🐳', keywords: 'spouting whale animal ocean', category: 'nature' },
    { char: '🐋', keywords: 'whale animal ocean', category: 'nature' },
    { char: '🦈', keywords: 'shark animal ocean', category: 'nature' },
    { char: '🐊', keywords: 'crocodile animal reptile', category: 'nature' },
    { char: '🐅', keywords: 'tiger animal', category: 'nature' },
    { char: '🐆', keywords: 'leopard animal', category: 'nature' },
    { char: '🦓', keywords: 'zebra animal', category: 'nature' },
    { char: '🦍', keywords: 'gorilla animal', category: 'nature' },
    { char: '🦧', keywords: 'orangutan animal', category: 'nature' },
    { char: '🐘', keywords: 'elephant animal', category: 'nature' },
    { char: '🦛', keywords: 'hippopotamus animal', category: 'nature' },
    { char: '🦏', keywords: 'rhinoceros animal', category: 'nature' },
    { char: '🐪', keywords: 'camel animal', category: 'nature' },
    { char: '🐫', keywords: 'two-hump camel animal', category: 'nature' },
    { char: '🦒', keywords: 'giraffe animal', category: 'nature' },
    { char: '🦘', keywords: 'kangaroo animal', category: 'nature' },
    { char: '🐃', keywords: 'water buffalo animal', category: 'nature' },
    { char: '🐂', keywords: 'ox animal', category: 'nature' },
    { char: '🐄', keywords: 'cow animal', category: 'nature' },
    { char: '🐎', keywords: 'horse animal', category: 'nature' },
    { char: '🐖', keywords: 'pig animal', category: 'nature' },
    { char: '🐏', keywords: 'ram animal', category: 'nature' },
    { char: '🐑', keywords: 'sheep animal', category: 'nature' },
    { char: '🦙', keywords: 'llama animal', category: 'nature' },
    { char: '🐐', keywords: 'goat animal', category: 'nature' },
    { char: 'deer', keywords: 'deer animal', category: 'nature' },
    { char: '🐕', keywords: 'dog animal', category: 'nature' },
    { char: '🐩', keywords: 'poodle dog animal', category: 'nature' },
    { char: '🦮', keywords: 'guide dog animal', category: 'nature' },
    { char: '🐕‍🦺', keywords: 'service dog animal', category: 'nature' },
    { char: '🐈', keywords: 'cat animal', category: 'nature' },
    { char: '🐈‍⬛', keywords: 'black cat animal', category: 'nature' },
    { char: '🐓', keywords: 'rooster animal', category: 'nature' },
    { char: '🦃', keywords: 'turkey animal', category: 'nature' },
    { char: '🦚', keywords: 'peacock animal', category: 'nature' },
    { char: '🦜', keywords: 'parrot animal bird', category: 'nature' },
    { char: '🦢', keywords: 'swan animal bird', category: 'nature' },
    { char: '🦩', keywords: 'flamingo animal bird', category: 'nature' },
    { char: '🕊', keywords: 'dove animal bird', category: 'nature' },
    { char: '🐇', keywords: 'rabbit animal bunny', category: 'nature' },
    { char: '🦝', keywords: 'raccoon animal', category: 'nature' },
    { char: '🦨', keywords: 'skunk animal', category: 'nature' },
    { char: '🦡', keywords: 'badger animal', category: 'nature' },
    { char: '🦦', keywords: 'otter animal', category: 'nature' },
    { char: '🦥', keywords: 'sloth animal', category: 'nature' },
    { char: '🐁', keywords: 'mouse animal', category: 'nature' },
    { char: '🐀', keywords: 'rat animal', category: 'nature' },
    { char: '🐿', keywords: 'chipmunk animal', category: 'nature' },
    { char: '🦔', keywords: 'hedgehog animal', category: 'nature' },
    { char: '🐾', keywords: 'paw prints animal', category: 'nature' },
    { char: '🐉', keywords: 'dragon animal fantasy', category: 'nature' },
    { char: '🐲', keywords: 'dragon face animal fantasy', category: 'nature' },

    // Objects
    { char: '⌚️', keywords: 'watch time', category: 'objects' },
    { char: '📱', keywords: 'mobile phone cell tech', category: 'objects' },
    { char: '💻', keywords: 'laptop computer tech work', category: 'objects' },
    { char: '⌨️', keywords: 'keyboard tech', category: 'objects' },
    { char: '🖥', keywords: 'desktop computer tech', category: 'objects' },
    { char: '🖨', keywords: 'printer tech', category: 'objects' },
    { char: '🖱', keywords: 'computer mouse tech', category: 'objects' },
    { char: '📸', keywords: 'camera photo', category: 'objects' },
    { char: '📺', keywords: 'television tv', category: 'objects' },
    { char: '💡', keywords: 'light bulb idea', category: 'objects' },
    { char: '💰', keywords: 'money bag dollar rich', category: 'objects' },
    { char: '💎', keywords: 'gem stone diamond rich', category: 'objects' },
    { char: '🔧', keywords: 'wrench tool fix', category: 'objects' },
    { char: '🔨', keywords: 'hammer tool fix', category: 'objects' },
    { char: '🛠', keywords: 'hammer and wrench tool fix', category: 'objects' },
    { char: '🔫', keywords: 'pistol gun weapon', category: 'objects' },
    { char: '💣', keywords: 'bomb weapon', category: 'objects' },
    { char: '🔪', keywords: 'kitchen knife weapon food', category: 'objects' },
    { char: '🛡', keywords: 'shield protect', category: 'objects' },
    { char: '💊', keywords: 'pill medicine health', category: 'objects' },
    { char: '🔑', keywords: 'key lock', category: 'objects' },
    { char: '📦', keywords: 'package box delivery', category: 'objects' },
    { char: '📄', keywords: 'page facing up document paper', category: 'objects' },
    { char: '📅', keywords: 'calendar date', category: 'objects' },
    { char: '📚', keywords: 'books read school', category: 'objects' },
    { char: '📎', keywords: 'paperclip office', category: 'objects' },
    { char: '✏️', keywords: 'pencil write draw', category: 'objects' },
    { char: '🔍', keywords: 'magnifying glass search find', category: 'objects' },
    { char: '🔒', keywords: 'locked lock secure', category: 'objects' },
    { char: '🔓', keywords: 'unlocked lock open', category: 'objects' },
];
